/**
 * <yg-carousel> — carosello circolare basato su FoxTheme.Carousel (Swiper),
 * lo stesso motore usato dalle sezioni native del tema.
 *
 * Arrivati all'ultimo elemento riparte dal primo: loop: true.
 *
 * Attributi:
 *   data-per-view          slide visibili da 768px in su
 *   data-per-view-tablet   slide visibili da 480px
 *   data-per-view-mobile   slide visibili sotto 480px
 *   data-gap               spazio tra le slide, px
 */
if (!customElements.get('yg-carousel')) {
  customElements.define(
    'yg-carousel',
    class YgCarousel extends HTMLElement {
      connectedCallback() {
        // theme.js definisce FoxTheme.Carousel; se per qualche motivo non c'e'
        // ancora, si riprova al load e nel frattempo resta una lista scorrevole.
        if (!window.FoxTheme || !window.FoxTheme.Carousel) {
          window.addEventListener('load', () => this.mount(), { once: true });
          return;
        }
        this.mount();
      }

      mount() {
        if (this.slider || !window.FoxTheme || !window.FoxTheme.Carousel) return;

        const container = this.querySelector('.swiper');
        if (!container) return;

        const perView = parseFloat(this.dataset.perView) || 3;
        const perViewTablet = parseFloat(this.dataset.perViewTablet) || 2;
        const perViewMobile = parseFloat(this.dataset.perViewMobile) || 1.15;
        const gap = parseInt(this.dataset.gap, 10) || 24;

        const slides = this.querySelectorAll('.swiper-slide').length;

        this.instance = new window.FoxTheme.Carousel(container, {
          slidesPerView: perViewMobile,
          spaceBetween: gap,
          breakpoints: {
            480: { slidesPerView: perViewTablet, spaceBetween: gap },
            768: { slidesPerView: perView, spaceBetween: gap },
          },
          // Swiper duplica le slide per simulare il ciclo: con meno slide che
          // posizioni visibili il loop si rompe, quindi lo si attiva solo
          // quando ce ne sono abbastanza.
          loop: slides > perView,
          watchOverflow: true,
          threshold: 2,
          grabCursor: true,
          a11y: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });

        this.instance.init();
        this.slider = this.instance.slider;
        this.classList.add('yg-carousel--ready');
      }

      disconnectedCallback() {
        if (this.slider && typeof this.slider.destroy === 'function') {
          this.slider.destroy();
          this.slider = null;
        }
      }
    }
  );
}
